import { AnswerWhereInput, ContextType } from '@/@generated/codegen/API';

export function getAnswerContextRelationWhereUnique(
  contextType: ContextType,
  objId: string
): Partial<AnswerWhereInput> {
  switch (contextType) {
    case ContextType.Meeting:
      return {
        meetingId: {
          equals: objId,
        },
      };
    case ContextType.Masterclass:
      return {
        masterClassUserSessionId: {
          equals: objId,
        },
      };
    default:
      throw new Error(`Unsupported context type: ${contextType as string}`);
  }
}
